import { render, staticRenderFns } from "./DTextareaField.vue?vue&type=template&id=148fa2fd"
import script from "./DTextareaField.vue?vue&type=script&lang=js"
export * from "./DTextareaField.vue?vue&type=script&lang=js"
import style0 from "./DTextareaField.vue?vue&type=style&index=0&id=148fa2fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports